import { KyInstance } from 'ky';

import { handleRequest } from '@/utils/httpUtils';

import type { GetWarehouses, WarehousesResponse } from './types';

export interface IReqWarehouses {
  getWarehouses: GetWarehouses;
}

export function reqWarehouses(http: KyInstance): IReqWarehouses {
  const route = 'api/v1/warehouses';
  return {
    getWarehouses: () => handleRequest<WarehousesResponse>(http, 'get', `${route}/user`),
  };
}
